import request from '@/utils/request'

// 查询店铺进件-拉卡拉分页
export function pageExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/page',
    method: 'post',
    data: data
  })
}

// 查询店铺进件-拉卡拉列表
export function listExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/list',
    method: 'post',
    data: data
  })
}

// 查询店铺进件-拉卡拉详情
export function getExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/detail',
    method: 'get',
    params: data
  })
}

// 新增店铺进件-拉卡拉
export function addExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/add',
    method: 'post',
    data: data
  })
}

// 修改店铺进件-拉卡拉
export function updateExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/edit',
    method: 'post',
    data: data
  })
}

// 删除店铺进件-拉卡拉
export function delExtraApplyLakala(data) {
  return request({
    url: '/shop/extra/apply/lakala/delete',
    method: 'post',
    data: data
  })
}

// 店铺进件
export function lakalaApply(data) {
  return request({
    url: '/shop/extra/apply/lakala/apply',
    method: 'get',
    params: data
  })
}

// 店铺进件修改
export function lakalaApplyEdit(data) {
  return request({
    url: '/shop/extra/apply/lakala/apply/edit',
    method: 'get',
    params: data
  })
}

// 分账申请
export function lakalaLedgerApply(data) {
  return request({
    url: '/shop/extra/apply/lakala/ledger/apply',
    method: 'get',
    params: data
  })
}

// 分账重新申请
export function lakalaLedgerUpdate(data) {
  return request({
    url: '/shop/extra/apply/lakala/ledger/update',
    method: 'get',
    params: data
  })
}

// 分账接收方申请
export function lakalaLedgerApplyReceiverNo(data) {
  return request({
    url: '/shop/extra/apply/lakala/ledger/apply/receiverNo',
    method: 'get',
    params: data
  })
}

// 电子合同获取地址(签署)
export function getEcUrl(data) {
  return request({
    url: '/shop/extra/apply/lakala/ec/url',
    method: 'get',
    params: data
  })
}

// 电子合同下载
export function downloadEc(data) {
  return request({
    url: '/shop/extra/apply/lakala/ec/download',
    method: 'get',
    params: data
  })
}

// 分账绑定关系
export function ledgerBind(data) {
  return request({
    url: '/shop/extra/apply/lakala/ledger/bind',
    method: 'get',
    params: data
  })
}

// 分账绑定关系查询
export function ledgerBindList(data) {
  return request({
    url: '/shop/extra/apply/lakala/ledger/bind/list',
    method: 'get',
    params: data
  })
}

// 报备详情
export function subInfo(data) {
  return request({
    url: '/shop/extra/apply/lakala/sub',
    method: 'get',
    params: data
  })
}

// 账户余额
export function balance(data) {
  return request({
    url: '/shop/extra/apply/lakala/balance',
    method: 'get',
    params: data
  })
}
